/* eslint-disable */
export default {
  DirectNumber: '直通',
  MainCompanyNumber: 'メイン',
  CompanyNumber: '会社',
  CompanyFaxNumber: 'FAX',
  Blocked: 'ブロック済み',
  AdditionalCompanyNumber: '会社',
  ForwardedCompanyNumber: '転送元',
  from: '発信元',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
